// extracted by mini-css-extract-plugin
export default {"searchVideos":"SearchVideoList_searchVideos__gClMY"};